import { Competency } from '@/models/competency/competency';

export class CompetencyScoreCompare {
  competency: Competency;
  beforeScore: number = 0;
  afterScore: number = 0;

  constructor(compe: Competency) {
    this.competency = compe;
  }

  get scoreDiff(): number {
    return this.afterScore - this.beforeScore;
  }
}

export class CompetencyScoreRanking {
  data: CompetencyScoreCompare[];

  constructor(val: CompetencyScoreCompare[]) {
    this.data = val;
  }

  // プラス成長（事前 -> 事後 でプラス）になっているものが存在するか
  // ランキングは「プラス成長しているものだけが対象」なので、0 やマイナスのものは含めない
  get hasRanking(): boolean {
    return this.data.find((compe: CompetencyScoreCompare) =>{
      if (compe.scoreDiff > 0) return compe;
    }) ? true : false;
  }

  get ranking(): CompetencyScoreCompare[] {
    return this.data.slice(0, 3);
  }
}